
export const results = {
  title: 'Tus Resultados',
  subtitle: 'Análisis conductual integral',
  cognitiveAssessmentCTA: 'Completa Tu Perfil',
  cognitiveAssessmentDescription: 'Realiza la Evaluación Cognitiva para obtener tu perfil completo',
  downloadPDF: 'Descargar PDF',
  header: {
    assessmentComplete: 'Evaluación Completa',
    yourResults: 'Tus Resultados'
  },
  navigation: {
    backToHome: 'Volver al Inicio'
  },
  pdfDownload: {
    success: {
      title: 'PDF Descargado',
      description: 'Tu reporte de evaluación conductual ha sido descargado exitosamente.'
    },
    error: {
      title: 'Falla en Exportación de PDF',
      description: 'No se pudo generar el PDF. Inténtalo nuevamente.'
    }
  },
  cinematic: {
    home: 'Inicio',
    discoverYourStory: 'Descubre Tu Historia',
    youAre: 'Tú Eres'
  },
  aiInsights: {
    aiPoweredAnalysis: 'Análisis Impulsado por IA',
    yourSuperpowers: 'Tus Fortalezas Clave',
    revealed: 'Reveladas',
    advancedAnalysis: 'El análisis avanzado de IA de tus patrones de personalidad revela tus fortalezas únicas y oportunidades de crecimiento',
    keySuperpowers: 'Tus Fortalezas Clave',
    deepInsights: 'Insights Profundos',
    title: 'Tus Fortalezas de Estilo de Trabajo',
    badge: 'Análisis Impulsado por IA',
    subtitle: 'Celebrando tus fortalezas únicas y áreas para crecimiento consciente',
    regenerate: 'Nuevo Análisis',
    regenerating: 'Regenerando...',
    backupBadge: 'Usando Análisis de Respaldo',
    keyInsights: 'Insights Clave',
    detailedAnalysis: 'Análisis Detallado'
  },
  objectivity: {
    thinkingStyle: 'Estilo de Pensamiento',
    decisionMakingStyle: 'Estilo de Toma de Decisiones',
    howYouMakeDecisions: 'Cómo Tomas Decisiones',
    uniqueApproach: 'Tu enfoque único para analizar información y tomar decisiones',
    highlyAnalytical: 'Altamente Analítico',
    dataDriven: 'Orientado por Datos',
    balancedApproach: 'Enfoque Equilibrado',
    peopleFocused: 'Enfocado en Personas',
    highlyIntuitive: 'Altamente Intuitivo',
    intuitiveLeader: 'Líder Intuitivo',
    intuitive: 'Intuitivo',
    balanced: 'Equilibrado',
    analytical: 'Analítico',
    descriptions: {
      veryHigh: 'Destacas en tomar decisiones puramente lógicas y basadas en hechos con claridad analítica excepcional.',
      high: 'Combinas pensamiento analítico fuerte con toma de decisiones práctica, favoreciendo los datos mientras mantienes flexibilidad.',
      moderate: 'Equilibras magistralmente el análisis lógico con la inteligencia emocional, considerando tanto hechos como personas.',
      low: 'Priorizas las relaciones y factores humanos mientras incorporas datos relevantes en tus decisiones.',
      veryLow: 'Lideras con intuición e inteligencia emocional, creando soluciones centradas en las personas que construyen relaciones sólidas.'
    }
  },
  personalityStory: {
    yourPersonalityStory: 'Tu Historia de Personalidad',
    selfVsWork: 'Comportamiento',
    analysis: 'Análisis',
    theDataBehind: 'Los Datos Detrás',
    yourUniqueness: 'Tu Singularidad',
    compareDescription: 'Compara cómo te ves a ti mismo con tus expectativas laborales',
    basedOnWords: 'Aquí está lo que te hace extraordinario',
    selfAssessment: 'Autoevaluación',
    workBehavior: 'Comportamiento Laboral',
    naturalSelf: 'Yo Natural',
    workPersona: 'Persona Laboral',
    yourBehavioralProfile: 'Tu Perfil Conductual',
    basedOnSelectedWords: 'Tus datos de comportamiento'
  },
  behavioral: {
    basedOnWords: 'Tu análisis de comportamiento',
    noDataAvailable: 'No hay datos disponibles para esta sección.',
    warningNoResults: 'Advertencia: No se encontraron resultados conductuales para esta sección.',
    warningDetails: 'Esto puede ocurrir si los datos no se cargaron correctamente o la evaluación estaba incompleta.',
    noChartData: 'No hay datos de gráfico disponibles.'
  },
  companyResults: {
    submittedTitle: 'Evaluación Enviada con Éxito',
    submittedSubtitle: 'Tus resultados han sido enviados de forma segura a la empresa. Aquí tienes un resumen de tu desempeño.',
    selfBehavior: 'Comportamiento Personal',
    workBehavior: 'Comportamiento Laboral',
    profile: 'Perfil',
    drive: 'Impulso',
    connection: 'Conexión',
    task: 'Tarea',
    order: 'Orden',
    aiInsightsTitle: 'Insights de Personalidad por IA',
    refresh: 'Actualizar',
    keyStrengths: 'Fortalezas Clave',
    growthAreas: 'Áreas de Crecimiento',
    recommendations: 'Recomendaciones',
    insightsError: 'No se pudieron generar los insights de IA. Intenta actualizar.',
    whatsNext: '¿Qué Sigue?',
    whatsNextDesc: 'Tus resultados han sido guardados y compartidos con el administrador de la evaluación. Revisarán tu perfil y pueden comunicarse contigo con los próximos pasos.',
    returnToHome: 'Volver al Inicio',
    workBehaviorProfile: 'Perfil de Comportamiento Laboral',
    yourProfile: 'Tu Perfil',
    submittedSubtitleBehavioral: 'Tus resultados han sido enviados de forma segura a la empresa. Aquí tienes un resumen de tu perfil conductual.',
    resultsSentSimple: 'Tus resultados han sido enviados de forma segura a la empresa.',
    thankYouMessage: 'Gracias por tu tiempo y esfuerzo al completar esta evaluación.',
    assessmentComplete: 'Evaluación Completada',
    cognitiveResultsSubtitle: 'Aquí están los resultados de tu evaluación cognitiva',
    overallCognitiveScore: 'Puntuación Cognitiva General',
    percentile: 'percentil',
    scoredHigherThan: 'Puntuaste más alto que el {{percentile}}% de los participantes',
    scoreBreakdown: 'Desglose de Puntuación',
    verbalReasoning: 'Razonamiento Verbal',
    verbalDescription: 'Comprensión lingüística y lógica verbal',
    numericalReasoning: 'Razonamiento Numérico',
    numericalDescription: 'Análisis matemático y cuantitativo',
    abstractReasoning: 'Razonamiento Abstracto',
    abstractDescription: 'Reconocimiento de patrones y pensamiento lógico',
    exceptional: 'Excepcional',
    aboveAverage: 'Por Encima del Promedio',
    average: 'Promedio',
    belowAverage: 'Por Debajo del Promedio',
    needsDevelopment: 'Necesita Desarrollo'
  }
};

export const factors = {
  // DCTOS Framework names
  drive: 'Impulso',
  connection: 'Conexión',
  task: 'Tarea',
  order: 'Orden',
  style: 'Estilo',
  // Legacy names (mapped to DCTOS)
  dominance: 'Impulso',
  extraversion: 'Conexión',
  patience: 'Tarea',
  formality: 'Orden',
  objectivity: 'Estilo',
  behavioralProfile: 'Perfil Conductual',
  descriptions: {
    // DCTOS descriptions
    drive: 'Cómo abordas problemas y desafíos',
    connection: 'Cómo interactúas e influences a otros',
    task: 'Cómo respondes al ritmo y cambios',
    order: 'Cómo respondes a reglas y procedimientos',
    style: 'Cómo procesas información y tomas decisiones',
    // Legacy descriptions
    dominance: 'Cómo abordas problemas y desafíos',
    extraversion: 'Cómo interactúas e influences a otros',
    patience: 'Cómo respondes al ritmo y cambios',
    formality: 'Cómo respondes a reglas y procedimientos',
    objectivity: 'Cómo procesas información y tomas decisiones'
  },
  category: {
    veryLow: 'Muy Bajo',
    low: 'Bajo',
    moderate: 'Moderado',
    high: 'Alto',
    veryHigh: 'Muy Alto'
  }
};

export const insights = {
  dominance: {
    veryHigh: 'Líder natural que genera resultados a través de acción decisiva',
    high: 'Toma iniciativa y se siente cómodo tomando decisiones importantes',
    moderate: 'Enfoque equilibrado para liderazgo y colaboración',
    low: 'Prefiere toma de decisiones colaborativa y consenso del equipo',
    veryLow: 'Fuerte preferencia por soluciones basadas en equipo'
  },
  extraversion: {
    veryHigh: 'Altamente social y energizado por interacciones con personas',
    high: 'Extrovertido y cómodo en situaciones sociales',
    moderate: 'Preferencias equilibradas de interacción social',
    low: 'Valora interacciones significativas uno-a-uno',
    veryLow: 'Prefiere ambientes de trabajo profundos y enfocados'
  },
  patience: {
    veryHigh: 'Extremadamente estable y prefiere ambientes consistentes',
    high: 'Paciente y deliberado en el enfoque',
    moderate: 'Adaptable a diferentes ritmos de trabajo',
    low: 'Prefiere ambientes dinámicos y de ritmo acelerado',
    veryLow: 'Prospera con cambios y toma de decisiones rápida'
  },
  formality: {
    veryHigh: 'Enfoque altamente sistemático y orientado a detalles',
    high: 'Valora estructura y sigue procedimientos establecidos',
    moderate: 'Equilibra estructura con flexibilidad',
    low: 'Pensamiento adaptativo e innovador',
    veryLow: 'Enfoque altamente flexible y creativo'
  },
  objectivity: {
    veryHigh: 'Toma decisiones basadas puramente en hechos y análisis lógico',
    high: 'Generalmente objetivo con buen pensamiento analítico',
    moderate: 'Equilibra análisis lógico con insights intuitivos',
    low: 'Considera emociones y relaciones junto con hechos',
    veryLow: 'Altamente intuitivo y valora inteligencia emocional'
  }
};

export const tabs = {
  overview: 'Resumen',
  detailed: 'Análisis Detallado',
  development: 'Desarrollo',
  career: 'Rutas Profesionales',
  words: 'Palabras'
};

export const professional = {
  style: {
    title: 'Estilo Profesional',
    subtitle: 'Tu enfoque natural para el trabajo y la colaboración'
  }
};

export const objectivity = {
  model: {
    calculated: 'Calculado',
    direct: 'Directo',
    reverse: 'Reverso'
  },
  description: {
    calculated: 'Basado en Formalidad menos Extroversión',
    direct: 'Basado en palabras de objetividad seleccionadas',
    reverse: 'Comienza en 100%, deduce para palabras subjetivas'
  }
};
